<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <navigation></navigation>
    <router-view></router-view>
    <slider></slider>
    <myfooter></myfooter>
  </div>
</template>

<script>
import Hello from './components/Hello'
import About from './components/About'
import Albums from './components/Albums'
import Service from './components/Service'
import Master from './components/Master'
import Navigation from './components/Navigation'
import Slider from './components/Slider'
import Myfooter from './components/Myfooter'
import './js/main'

export default {
  name: 'app',
  components: {
    Hello,
    About,
    Albums,
    Service,
    Master,
    Navigation,
    Slider,
    Myfooter
  }
}
</script>

<style lang="scss">
  @import "./sass/main";
</style>



// WEBPACK FOOTER //
// src/App.vue?3a9b6ad1